import { FC } from 'react'

import { Box, Link, Typography } from '@mui/material'
import { HOME_PAGE } from 'constants/routes'

import RectangleButtonComponent from 'components/RectangleButton'

import NotFoundIcon from 'assets/images/404.svg'
import LeftArrowIcon from 'assets/images/LeftArrow.svg'

import { styles } from './ErrorPage.styles'

export type Props = {
	message?: string
}

const ErrorPage: FC<Props> = ({ message = '' }) => {
	return (
		<Box data-testid="error__page" sx={styles.root}>
			<Box sx={styles.IconContainer}>
				<img
					alt="not-found-icon"
					src={NotFoundIcon as unknown as string}
				/>
			</Box>
			<Box sx={styles.TextContainer}>
				<Typography sx={styles.TextField}>{message}</Typography>
			</Box>

			<Box sx={styles.btnContainer}>
				<RectangleButtonComponent
					iconSvg={LeftArrowIcon}
					data-testid="return__home__button"
					href={HOME_PAGE}
					text={'go home'}
					color="secondary"
					sx={styles.GoHome}
					typographySx={styles.GoHome}
				/>

				<Link
					role="contactAdmin"
					color={'secondary'}
					underline="none"
					href={'https://go.slalom.com/brainstorm-support'}
					target="_blank"
				>
					<Typography sx={styles.ContactAnAdmin}>
						CONTACT OUR TEAM
					</Typography>
				</Link>
			</Box>
		</Box>
	)
}

export default ErrorPage
